import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import PrivateRoute from '../../utils/PrivateRoute/PrivateRoute';
import Loader from '../../common/Loader/Loader';
import { LINKS_ROUTES, LINKS_ROUTE_CONFIG } from './core/constants/routes';

const LinksListPage = lazy(() => import('./workflow/list/LinksListPage'));
const CampaignsIndexPage = lazy(() => import('./workflow/campaigns/CampaignsIndexPage'));
const CampaignPage = lazy(() => import('./workflow/campaigns/CampaignPage'));
const OverviewPage = lazy(() => import('./workflow/overview/OverviewPage'));
const LinkDetailPage = lazy(() => import('./workflow/detail/LinkDetailPage'));
const FormsListPage = lazy(() => import('./workflow/forms/FormsListPage'));
const FormPage = lazy(() => import('./workflow/forms/FormPage'));
const FormEditorPage = lazy(() => import('./workflow/formEditor/FormEditorPage'));
const FormSetupPage = lazy(() => import('./workflow/formSetup/FormSetupPage'));
const ConsentTextsPage = lazy(() => import('./workflow/consent/ConsentTextsPage'));

const PAGE_BY_PATH = {
  [LINKS_ROUTES.LIST]: LinksListPage,
  [LINKS_ROUTES.FORMS]: FormsListPage,
  [LINKS_ROUTES.FORM_NEW]: FormSetupPage,
  [LINKS_ROUTES.FORM_CONSENT]: ConsentTextsPage,
  [LINKS_ROUTES.FORM_DETAIL]: FormPage,
  [LINKS_ROUTES.FORM_EDIT]: FormEditorPage,
  [LINKS_ROUTES.CAMPAIGNS]: CampaignsIndexPage,
  [LINKS_ROUTES.CAMPAIGN_DETAIL]: CampaignPage,
  [LINKS_ROUTES.OVERVIEW]: OverviewPage,
  [LINKS_ROUTES.DETAIL]: LinkDetailPage,
};

function LinksShell({ element: Page }) {
  return (
    <Suspense fallback={<Loader />}>
      <PrivateRoute element={Page} />
    </Suspense>
  );
}

/** Pre-built Route elements for App.js, next to the diet routes (U09). */
export const linksRouteElements = (
  <>
    {LINKS_ROUTE_CONFIG.map(({ path }) => (
      <Route key={path} path={path} element={<LinksShell element={PAGE_BY_PATH[path]} />} />
    ))}
  </>
);
